import { Space } from 'antd';
import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import { Radio } from 'components/atoms/radio';
import { TaskConflictRadioOptions } from './date-conflict-modal';

interface Props {
  selected: TaskConflictRadioOptions;
  onChange: (latest: TaskConflictRadioOptions) => void;
}

const Description = styled.div`
  margin: var(--spacing-06) 0 var(--spacing-07);
  width: 80%;
`;

export const RadioOptions: FC<Props> = ({ selected, onChange }) => {
  const handleRadioChange = (e) => {
    const {
      target: { value },
    } = e;

    onChange(value);
  };

  return (
    <Description>
      <Radio.Group value={selected} onChange={handleRadioChange}>
        <Space direction="vertical">
          <Radio value={TaskConflictRadioOptions.AutoAdjustTask}>
            <Space size={2} direction="vertical">
              <div>
                <FormattedMessage id="tasks.auto_adjust_task" />
              </div>
            </Space>
          </Radio>
          <Radio value={TaskConflictRadioOptions.AutoAdjustPhase}>
            <Space size={2} direction="vertical">
              <div>
                <FormattedMessage id="tasks.auto_adjust_phase" />
              </div>
            </Space>
          </Radio>
        </Space>
      </Radio.Group>
    </Description>
  );
};
